import { create } from 'zustand';

import type { ImportActivityDrawerStore, OnImportActivitiesCallback } from './types';

export const useImportActivityDrawer = create<ImportActivityDrawerStore>(set => ({
  isOpen: false,
  sectionId: undefined,
  onImport: undefined,
  openDrawer: (callback: OnImportActivitiesCallback, sectionId: string) =>
    set({ isOpen: true, onImport: callback, sectionId }),
  closeDrawer: () => set({ isOpen: false, onImport: undefined, sectionId: undefined })
}));
